const groupContactSpeakFields = (fields) => {
  const introFields = fields
    .filter((field) => ['eyebrow', 'title', 'text'].includes(field.key))
    .sort((a, b) => a.sortOrder - b.sortOrder);
  const itemGroups = [];

  for (let index = 1; index <= 10; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`item-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `item-${index}-label`)) {
      break;
    }

    itemGroups.push({ index, fields: groupFields });
  }

  return { introFields, itemGroups };
};

export default groupContactSpeakFields;
